import { MenuItem } from '@/core/models';
import { CartCalculationRule, CartDomainContext } from '..';
import { MenuItemValidatorUtil } from '../utils';

export class CartStockCalculationRule implements CartCalculationRule {
	/**
	 * Actualiza el stock de los menu items del carrito con los datos recibidos desde los microservicios.
	 */
	calculate(context: CartDomainContext): CartDomainContext {
		try {
			const menuItems: MenuItem[] = context.menuItems.map(cartItem => {
				const cloudMenuItem = context.cloudMenuItems
					?.filter(item => this.isValid(item))
					?.find(item => item.idArticulo === cartItem.idArticulo);

				return {
					...cartItem,
					isUnavailable: !cloudMenuItem,
					stock: cloudMenuItem
						? cloudMenuItem.stock === null || cloudMenuItem.stock === undefined
							? null
							: Math.floor(Number(cloudMenuItem.stock))
						: cartItem.stock,
				};
			});


			return {
				...context,
				menuItems,
			};
		} catch (error) {
			console.error(error);
			return context;
		}
	}

	/**
	 * Validaciones de los menu items antes de sincronizar
	 */
	private isValid(menuItem: MenuItem): boolean {
		return MenuItemValidatorUtil.isValid(menuItem);
	}
}
